// extracted by mini-css-extract-plugin
module.exports = {"VideoActivityInput":"VideoActivity_VideoActivityInput__2XRQ5"};